import { SiFastly } from "react-icons/si";

const FastIcon = (props) => {
  return <SiFastly className={props.className} />;
};

export default FastIcon;
